// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__31h3B","content":"GlobalSearch_content__3Vbrz"};